import McmVirtualConfig from '~/tenants/mcm/performable/virtual/McmVirtualConfig';
import McmJob from '~/tenants/mcm/model/McmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { TenantJobLine } from '~/lib/model';
import { Big } from 'big.js';

export default class McmVirtualJob extends McmJob<typeof McmVirtualConfig> {
  get performable() {
    return McmVirtualConfig;
  }

  defaultValue(): ZodVersionedMetadata<(typeof McmVirtualConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      photos: 1,
    };
  }

  get assignable(): boolean {
    return true;
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = [];
    const photos = this.metadata.photos || 1;

    lines.push({
      id: 'virtual_twilight',
      description: `Virtual Twilight (${photos} photo${photos > 1 ? 's' : ''})`,
      amount: new Big(30).times(photos),
    });

    return lines;
  }

  onsite(): number {
    return 0;
  }

  get eligible(): boolean {
    return !this.buyer('crossroads');
  }

  get configurable() {
    return true;
  }
}
